import { Recnum, UUID } from '../../types/common';
import { DTO } from '../../utilities/Dto';

// ---------------------------------------------------------------------------
// Feedback (matches qa.list_feedback via api.list_feedback view)
// ---------------------------------------------------------------------------

export interface Feedback {
  id: UUID;
  user_id: Recnum;
  handled: boolean;
  handled_user_id: Recnum | null;
  message: string;
  proto_list_id: UUID | null;
  proto_node_id: UUID | null;
  instance_list_id: UUID | null;
  instance_node_id: UUID | null;
  timestamp: Date;
  updated: Date;
}

// ---------------------------------------------------------------------------
// Create payload
// ---------------------------------------------------------------------------

export interface CreateFeedbackPayload {
  message: string;
  user_id: Recnum;
  proto_list_id: UUID;
  proto_node_id: UUID;
  instance_list_id: UUID;
  instance_node_id: UUID;
}

// ---------------------------------------------------------------------------
// DTO parsing
// ---------------------------------------------------------------------------

export function parseFeedbackDto(dto: DTO<Feedback>): Feedback {
  return {
    ...dto,
    timestamp: new Date(dto.timestamp),
    updated: new Date(dto.updated),
  };
}
